export default __webpack_public_path__ + "static/media/transfer-send-step6.fc27c934.png";